export const transactionFormatter = transactionId => {
  if (!transactionId) {
    return transactionId;
  }
  return `${transactionId.slice(0, 7)}...${transactionId.slice(
    transactionId.length - 7,
    transactionId.length,
  )}`;
};
